import { Subject } from "rxjs";
import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandService } from "~app/common/services/cqs/command.service";
import { ICommand } from "~app/common/services/cqs/model-action.service";

export abstract class CommandControlBinderBase {

    onUpdate = new Subject<any>();

    constructor(protected readonly commandService: CommandService) {

    }

    protected setValue(mapExpression, command, value) {
        if (typeof (mapExpression) === "function") {
            return mapExpression(value, command);
        }
        command[mapExpression] = value;
        return null;
    }

    protected clearCommand(command: ICommand) {
        this.commandService.removeCommand(command);
    }

    protected addCommand(command: ICommand, valueExpression, value, allowEmpty = false) {
        if (!allowEmpty && (value === undefined || value === null || value?.length === 0)) {
            return;
        }
        this.setValue(valueExpression, command, value);
        this.push(command);
    }

    protected push(command: ICommand) {
        this.commandService.addTransactionCommand(command);
        this.onUpdate.next(command);
    }

    protected getCommand<T>(type: new (...args) => BasicCommand<T>, ...args: any[]) {
        return new type(...args) as ICommand;
    }
}
